import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
    formControl: {
        marginTop: '8px',
    },
});
